import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import EnhancedProjectCards from "./EnhancedProjectCards";
import Particle from "../Particle";

function GitHubProjects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchGitHubProjects();
  }, []);

  const fetchGitHubProjects = async () => {
    try {
      // Fetch pinned repositories from GitHub API
      const response = await fetch('https://api.github.com/users/devbm7/repos?sort=updated&per_page=100');
      const repos = await response.json();

      if (!response.ok) {
        throw new Error('Failed to fetch projects');
      }

      // Filter and format projects - only show pinned repos or specific repos you want
      const formattedProjects = repos
        .filter(repo => {
          // Filter for specific projects you want to show
          const wantedProjects = [
            'QGen', // Question Generator System
            'StyleStackAN', // Clothes and Laundry Management
            'rexplain',
            'json-viewer',
            'Synth-Gen',
            'Text2SQL', // Natural Language to SQL Query
            // Add more project names as you pin them on GitHub
          ];
          return wantedProjects.includes(repo.name) && !repo.private;
        })
        .map(repo => ({
          id: repo.id,
          title: repo.name,
          description: repo.description || 'No description available',
          ghLink: repo.html_url,
          demoLink: repo.homepage || null,
          language: repo.language,
          stars: repo.stargazers_count,
          forks: repo.forks_count,
          updated: repo.updated_at
        }))
        .slice(0, 6); // Limit to 6 projects

      setProjects(formattedProjects);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };



  if (loading) {
    return (
      <Container fluid className="project-section">
        <Particle />
        <Container>
          <h1 className="project-heading">
            My Recent <strong className="purple">Works </strong>
          </h1>
          <p style={{ color: "white" }}>Loading projects from GitHub...</p>
        </Container>
      </Container>
    );
  }

  if (error) {
    return (
      <Container fluid className="project-section">
        <Particle />
        <Container>
          <h1 className="project-heading">
            My Recent <strong className="purple">Works </strong>
          </h1>
          <p style={{ color: "white" }}>Error loading projects: {error}</p>
        </Container>
      </Container>
    );
  }

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects from my GitHub profile.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projects.map((project) => (
            <Col md={4} className="project-card" key={project.id}>
              <EnhancedProjectCards
                isBlog={false}
                title={project.title}
                description={project.description}
                ghLink={project.ghLink}
                demoLink={project.demoLink}
                language={project.language}
                stars={project.stars}
                forks={project.forks}
                updated={project.updated}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default GitHubProjects; 